import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconLargeCicle from '../../shared/IconLargeCicle';
import BuildIcon from '@mui/icons-material/Build';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function ContentNotFoundRoot() {
  return (
    <>
      <IconLargeCicle>
        <BuildIcon />
      </IconLargeCicle>

      <Typography variant="h2" sx={{ mb: 3 }}>
        Ops! Estamos em manutenção.
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Nossa equipe está trabalhando nos bastidores para melhorar sua experiência. Voltamos rapidinho!
      </Typography>

      <Button variant="contained" endIcon={<WhatsAppIcon />} href="https://bit.ly/Fale_com_a_Oya" target="_blank">
        Fale com a gente
      </Button>
    </>
  );
}
